<template>
  <div
    class="multiselect-wrapper"
    :class="{
      'has-error': !!isError,
    }"
  >
    <multiselect
      class="col p-0"
      :class="{
        'required': isRequired,
        'is-invalid': !!isError,
      }"
      :value="value"
      :options="options"
      :multiple="false"
      :placeholder="placeholder"
      :track-by="trackBy"
      :custom-label="customLabel || productLabel"
      :selectLabel="selectLabel"
      :selectedLabel="selectedLabel"
      :deselectLabel="deselectLabel"
      :disabled="disabled"
      :allow-empty="allowEmpty"
      openDirection="below"
      @open="$emit('open')"
      @input="$emit('input', $event)"
    >
      <span slot="noResult">{{ noResultLabel }}</span>
    </multiselect>
    <svg
      v-if="showErrorIcon && !!isError"
      class="multiselect-invalid-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#dc3545"
      stroke-width="2"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <circle cx="12" cy="16.5" r="0.5" fill="#dc3545" stroke="none" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "MultipleSelectField",
  props: {
    isRequired: {
      default: false,
    },
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    isError: {
      default: false,
    },
    placeholder: {
      type: String,
      default: "เลือกสินค้า",
    },
    trackBy: {
      type: String,
      default: "productId",
    },
    customLabel: {
      type: Function,
      default: null,
    },
    selectLabel: {
      type: String,
      default: "เลือกสินค้า",
    },
    selectedLabel: {
      type: String,
      default: "เลือกแล้ว",
    },
    deselectLabel: {
      type: String,
      default: "คลิกเพื่อลบออก",
    },
    noResultLabel: {
      type: String,
      default: "ไม่พบรายการ",
    },
    disabled: {
      default: false,
    },
    allowEmpty: {
      default: true,
    },
    showErrorIcon: {
      default: true,
    },
  },
  methods: {
    productLabel(item) {
      if (!item) return "";
      return `${item.productCode} - ${item.productNameMain}`;
    },
  },
};
</script>

<style scoped>
.multiselect-wrapper {
  position: relative;
}

.multiselect-invalid-icon {
  position: absolute;
  top: 50%;
  right: 36px;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
  width: 20px;
  height: 20px;
}

.multiselect-wrapper.has-error ::v-deep .multiselect {
  border-color: #dc3545;
}

::v-deep .multiselect.is-invalid {
  border-color: #dc3545;
}

.required {
  background-color: #ccecff6c;
}

::v-deep .multiselect__tags {
  background-color: transparent;
}

::v-deep .multiselect__select {
  background-color: transparent;
}

::v-deep .multiselect--disabled .multiselect__tags {
  background-color: #e9ecef;
}

::v-deep .multiselect--disabled .multiselect__select {
  background-color: transparent;
}

::v-deep .multiselect__single,
::v-deep .multiselect__input,
::v-deep .multiselect__placeholder {
  background-color: transparent !important;
}

::v-deep span.multiselect__placeholder {
  margin-left: 6px !important;
}

::v-deep .multiselect__input,
::v-deep .multiselect__single {
  padding-left: 6px;
}

::v-deep span.multiselect__single {
  margin-left: 6px !important;
}

::v-deep .multiselect__single {
  margin-bottom: 0;
  padding-left: 0;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
  text-overflow: unset;
}
</style>
